// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_background__C8uC8 {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: grid;
  grid-template-columns: 65vw 35vw;
  z-index: 100;
}
@media only screen and (max-width: 75em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 57vw 43vw;
  }
}
@media only screen and (max-width: 62.5em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 50vw 50vw;
  }
}
@media only screen and (max-width: 50em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 35vw 65vw;
  }
}
@media only screen and (max-width: 31.25em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 100vw;
    grid-template-rows: 1fr max-content;
  }
}

.Modal_container__LE2t1 {
  width: 100%;
  min-height: 100vh;
  background-color: var(--color-white);
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 3rem;
  position: relative;
  bottom: 0;
  grid-column: 2/3;
  overflow-y: scroll;
  overflow-x: hidden;
}
.Modal_container__LE2t1::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
}
.Modal_container__LE2t1::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 1rem;
}
@media only screen and (max-width: 31.25em) {
  .Modal_container__LE2t1 {
    grid-column: 1/1;
    border-radius: 5rem 5rem 0 0;
    min-height: 30vh;
    max-height: 85vh;
  }
}
.Modal_container__top__4QJFC {
  z-index: 10;
  height: 10rem;
  position: relative;
}
.Modal_container__top__inner__tB94p {
  position: fixed;
  background-color: var(--color-white);
  font-size: 5rem;
  display: flex;
  justify-content: space-between;
  height: 10rem;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 1rem;
  z-index: 10;
  top: 0;
  padding-top: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .Modal_container__top__inner__tB94p {
    top: auto;
    height: 10rem;
  }
}
.Modal_container__top__inner__tB94p > :first-child {
  cursor: pointer;
}
.Modal_container__top__inner__tB94p > :first-child:hover {
  color: var(--color-primary);
}

.Modal_bws__1xdpZ {
  content: "";
  background-color: var(--color-white);
  width: 100%;
  height: 2rem;
}

.Modal_content__z2Bau {
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}
@media only screen and (max-width: 31.25em) {
  .Modal_content__z2Bau {
    min-height: -moz-fit-content;
    min-height: fit-content;
    margin: 3rem 0 8rem;
  }
}

.Modal_close__XMVHQ {
  position: fixed;
  right: 3rem;
  cursor: pointer;
  z-index: 10;
}

.Modal_center__background__s3WxQ {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.Modal_center__container__8Li6- {
  min-width: 50%;
  min-height: 50vh;
  max-width: 70%;
  max-height: 80vh;
  background-color: var(--color-white);
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 3rem;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}
@media only screen and (max-width: 43.75em) {
  .Modal_center__container__8Li6- {
    max-width: 90%;
  }
}
.Modal_center__top__2Pu8t {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.Modal_center__top__2__cZSCp {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
}

.Modal_dispute__metrics__0t1Cu {
  width: 100%;
  border-collapse: collapse;
  margin: 2rem 0;
  font-size: 1.4rem;
  text-align: left;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  overflow: hidden;
}
.Modal_dispute__metrics__0t1Cu th,
.Modal_dispute__metrics__0t1Cu td {
  padding: 1rem;
  border-bottom: 1px solid #ddd;
}
.Modal_dispute__metrics__0t1Cu th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x {
  font-weight: 600;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x.Modal_green__s9ny\\+ {
  color: #28a745;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x.Modal_yellow__7QuqE {
  color: #ffc107;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x.Modal_orange__RBgGh {
  color: #fd7e14;
}
.Modal_dispute__metrics__0t1Cu td.Modal_status__Uw-2x.Modal_red__hpPFi {
  color: #dc3545;
}
.Modal_dispute__metrics__0t1Cu tr:last-child td {
  border-bottom: none;
}
@media (max-width: 768px) {
  .Modal_dispute__metrics__0t1Cu {
    font-size: 0.9rem;
  }
  .Modal_dispute__metrics__0t1Cu th,
  .Modal_dispute__metrics__0t1Cu td {
    padding: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Modal/Modal.module.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;AADF;AAGE;EATF;IAUI,gCAAA;EAAF;AACF;AACE;EAZF;IAaI,gCAAA;EAEF;AACF;AAAE;EAhBF;IAiBI,gCAAA;EAGF;AACF;AADE;EApBF;IAqBI,4BAAA;IACA,mCAAA;EAIF;AACF;;AADA;EACE,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAIF;AAFE;EACE,WAAA;EACA,oCAAA;EACA,4BAAA;AAIJ;AADE;EACE,mCAAA;EACA,mBAAA;AAGJ;AAAE;EAxBF;IAyBI,gBAAA;IACA,4BAAA;IACA,gBAAA;IACA,gBAAA;EAGF;AACF;AADE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAGJ;AADI;EACE,eAAA;EACA,oCAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,iBAAA;AAGN;AADM;EAbF;IAcI,SAAA;IACA,aAAA;EAIN;AACF;AAFM;EACE,eAAA;AAIR;AAFQ;EACE,2BAAA;AAIV;;AAGA;EACE,WAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAAF;AAEE;EATF;IAUI,4BAAA;IAAA,uBAAA;IACA,mBAAA;EACF;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AACF;;AAGE;EACE,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAAJ;AAGE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AADJ;AAGI;EAdF;IAeI,cAAA;EAAJ;AACF;AAGE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AADN;;AAOE;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AAJJ;AAMI;;EAEE,aAAA;EACA,6BAAA;AAJN;AAOI;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;AALN;AAQI;EACE,gBAAA;AANN;AAOM;EACE,cAAA;AALR;AAOM;EACE,cAAA;AALR;AAOM;EACE,cAAA;AALR;AAOM;EACE,cAAA;AALR;AASI;EACE,mBAAA;AAPN;AAUI;EA1CF;IA2CI,iBAAA;EAPJ;EAQI;;IAEE,gBAAA;EANN;AACF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.background {\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(#2a2828, 0.7);\n  position: fixed;\n  display: grid;\n  grid-template-columns: 65vw 35vw;\n  z-index: 100;\n\n  @media only screen and (max-width: $bp-1200) {\n    grid-template-columns: 57vw 43vw;\n  }\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 50vw 50vw;\n  }\n\n  @media only screen and (max-width: $bp-800) {\n    grid-template-columns: 35vw 65vw;\n  }\n\n  @media only screen and (max-width: $bp-500) {\n    grid-template-columns: 100vw;\n    grid-template-rows: 1fr max-content;\n  }\n}\n\n.container {\n  width: 100%;\n  min-height: 100vh;\n  background-color: var(--color-white);\n  box-sizing: border-box;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  padding: 3rem;\n  position: relative;\n  bottom: 0;\n  grid-column: 2/3;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &::-webkit-scrollbar {\n    width: 1rem;\n    background-color: var(--color-white);\n    border-radius: 0 1rem 1rem 0;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-grey);\n    border-radius: 1rem;\n  }\n\n  @media only screen and (max-width: $bp-500) {\n    grid-column: 1/1;\n    border-radius: 5rem 5rem 0 0;\n    min-height: 30vh;\n    max-height: 85vh;\n  }\n\n  &__top {\n    z-index: 10;\n    height: 10rem;\n    position: relative;\n\n    &__inner {\n      position: fixed;\n      background-color: var(--color-white);\n      font-size: 5rem;\n      display: flex;\n      justify-content: space-between;\n      height: 10rem;\n      width: fit-content;\n      margin-right: 1rem;\n      z-index: 10;\n      top: 0;\n      padding-top: 2rem;\n\n      @media only screen and (max-width: $bp-500) {\n        top: auto;\n        height: 10rem;\n      }\n\n      & > :first-child {\n        cursor: pointer;\n\n        &:hover {\n          color: var(--color-primary);\n        }\n      }\n    }\n  }\n}\n\n.bws {\n  content: \"\";\n  background-color: var(--color-white);\n  width: 100%;\n  height: 2rem;\n}\n\n.content {\n  min-height: 75vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n\n  @media only screen and (max-width: $bp-500) {\n    min-height: fit-content;\n    margin: 3rem 0 8rem;\n  }\n}\n\n.close {\n  position: fixed;\n  right: 3rem;\n  cursor: pointer;\n  z-index: 10;\n}\n\n.center {\n  &__background {\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(#2a2828, 0.7);\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100;\n  }\n\n  &__container {\n    min-width: 50%;\n    min-height: 50vh;\n    max-width: 70%;\n    max-height: 80vh;\n    background-color: var(--color-white);\n    box-sizing: border-box;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n    padding: 3rem;\n    position: relative;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    position: relative;\n\n    @media only screen and (max-width: $bp-700) {\n      max-width: 90%;\n    }\n  }\n\n  &__top {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    &__2 {\n      display: flex;\n      justify-content: space-between;\n      gap: 1rem;\n      align-items: center;\n    }\n  }\n}\n\n.dispute {\n  &__metrics {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 2rem 0;\n    font-size: 1.4rem;\n    text-align: left;\n    border: 1px solid #ddd;\n    border-radius: 0.5rem;\n    overflow: hidden;\n\n    th,\n    td {\n      padding: 1rem;\n      border-bottom: 1px solid #ddd;\n    }\n\n    th {\n      background-color: #f5f5f5;\n      font-weight: 600;\n      color: #333;\n    }\n\n    td.status {\n      font-weight: 600;\n      &.green {\n        color: #28a745;\n      } // Bootstrap Green\n      &.yellow {\n        color: #ffc107;\n      } // Bootstrap Yellow\n      &.orange {\n        color: #fd7e14;\n      } // Bootstrap Orange\n      &.red {\n        color: #dc3545;\n      } // Bootstrap Red\n    }\n\n    tr:last-child td {\n      border-bottom: none;\n    }\n\n    @media (max-width: 768px) {\n      font-size: 0.9rem;\n      th,\n      td {\n        padding: 0.75rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `Modal_background__C8uC8`,
	"container": `Modal_container__LE2t1`,
	"container__top": `Modal_container__top__4QJFC`,
	"container__top__inner": `Modal_container__top__inner__tB94p`,
	"bws": `Modal_bws__1xdpZ`,
	"content": `Modal_content__z2Bau`,
	"close": `Modal_close__XMVHQ`,
	"center__background": `Modal_center__background__s3WxQ`,
	"center__container": `Modal_center__container__8Li6-`,
	"center__top": `Modal_center__top__2Pu8t`,
	"center__top__2": `Modal_center__top__2__cZSCp`,
	"dispute__metrics": `Modal_dispute__metrics__0t1Cu`,
	"status": `Modal_status__Uw-2x`,
	"green": `Modal_green__s9ny+`,
	"yellow": `Modal_yellow__7QuqE`,
	"orange": `Modal_orange__RBgGh`,
	"red": `Modal_red__hpPFi`
};
export default ___CSS_LOADER_EXPORT___;
